import { render, staticRenderFns } from "./RflmCalculatingSpouseSupport.vue?vue&type=template&id=9f9d28e6"
import script from "./RflmCalculatingSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./RflmCalculatingSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports